<template>
  <div class="space-y-4">
    <p class="text-[1.3rem] font-medium text-black">
      {{ $t("Personal information") }}
    </p>
    <div class="grid gap-4 xl:grid-cols-2">
      <label class="flex flex-col gap-1 text-[1.2rem] text-[color:var(--gray)]">
        {{ $t("Name *") }}
        <input
          type="text"
          :value="name"
          class="w-full rounded-xl border border-black/10 bg-black/[0.06] px-3 py-2 text-[1.4rem] text-black/70 cursor-not-allowed"
          readonly
        />
      </label>
      <label class="flex flex-col gap-1 text-[1.2rem] text-[color:var(--gray)]">
        {{ $t("Last Name") }}
        <input
          type="text"
          :value="surname"
          class="w-full rounded-xl border border-black/10 bg-black/[0.06] px-3 py-2 text-[1.4rem] text-black/70 cursor-not-allowed"
          readonly
        />
      </label>
      <label
        class="flex flex-col gap-1 text-[1.2rem] text-[color:var(--gray)] xl:col-span-2"
      >
        {{ $t("Message for the specialist (optional)") }}
        <textarea
          :value="comment"
          class="min-h-[120px] w-full rounded-xl border border-black/10 bg-white px-3 py-2 text-[1.4rem] text-black focus:border-black/30 focus:outline-none"
          @input="$emit('update:comment', $event.target.value)"
        ></textarea>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckoutPersonalInfo",
  props: {
    name: {
      type: String,
      default: "",
    },
    surname: {
      type: String,
      default: "",
    },
    comment: {
      type: String,
      default: "",
    },
  },
  emits: ["update:comment"],
};
</script>
